/**
 * Maps a Google Geocoding or Place Details "result" object into Docket Forms address fields.
 * @param {object} result — must include address_components (and optionally geometry, formatted_address)
 */
export function mapGoogleAddressComponentsToFormAddress(result) {
  if (!result || !Array.isArray(result.address_components)) {
    return null;
  }
  const components = result.address_components;
  let streetNumber = '';
  let route = '';
  let city;
  let cityBackup;
  let cityBackup2;
  let county;
  let countyVerbose;
  let state;
  let postal = '';
  let countryCode = '';

  for (let i = 0; i < components.length; i++) {
    const c = components[i];
    const types = c.types || [];
    for (let j = 0; j < types.length; j++) {
      const type = types[j];
      if (type === 'street_number') {
        streetNumber = c.long_name;
      } else if (type === 'route') {
        route = c.long_name;
      } else if (type === 'locality') {
        city = c.long_name;
      } else if (type === 'administrative_area_level_3') {
        cityBackup = c.long_name;
      } else if (type === 'neighborhood') {
        cityBackup2 = c.long_name;
      } else if (type === 'administrative_area_level_2') {
        countyVerbose = c.long_name;
        if (countyVerbose && countyVerbose.endsWith('County')) {
          county = countyVerbose.substring(0, countyVerbose.indexOf(' County'));
        }
      } else if (type === 'administrative_area_level_1') {
        let isPuertoRico = false;
        for (let a = 0; a < components.length; a++) {
          const ic = components[a];
          for (let b = 0; b < (ic.types || []).length; b++) {
            if (ic.types[b] === 'country' && ic.long_name === 'Puerto Rico') {
              isPuertoRico = true;
              break;
            }
          }
        }
        if (!isPuertoRico) {
          state = c.long_name;
        }
      } else if (type === 'country') {
        countryCode = c.short_name || '';
        if (c.long_name === 'Puerto Rico') {
          state = c.long_name;
        }
      } else if (type === 'postal_code') {
        postal = c.long_name || '';
      }
    }
  }

  if (city === undefined && cityBackup !== undefined) {
    city = cityBackup;
  } else if (city === undefined && cityBackup === undefined && cityBackup2 !== undefined) {
    city = cityBackup2;
  }

  const line1 = [streetNumber, route].filter(Boolean).join(' ').trim();
  const addressLine1 =
    line1 || (typeof result.formatted_address === 'string' ? result.formatted_address.split(',')[0].trim() : '');

  let location;
  if (result.geometry && result.geometry.location) {
    const loc = result.geometry.location;
    const lat = typeof loc.lat === 'function' ? loc.lat() : loc.lat;
    const lng = typeof loc.lng === 'function' ? loc.lng() : loc.lng;
    location = { latitude: lat, longitude: lng };
  }

  return {
    addressLine1,
    city,
    state,
    zip: postal,
    county,
    countyVerbose,
    countryCode,
    location,
  };
}
